$('.tabs__btn').on('click', function () {
  $(this)
    .addClass('active').siblings().removeClass('active')
    .closest('.tabs').find('.tabs__content').removeClass('active')
    .eq($(this).index()).addClass('active');
});